import React, { useContext, useRef, useState } from 'react'
import "./contact.css"
import Phone from "../../img/phone.png"
import Email from "../../img/email.png"
import Address from "../../img/address.png"
import emailjs from 'emailjs-com'
import { ThemeContext } from '../../context'

const Contact = () => {
    const formRef=useRef()
    const [done,setDone]=useState(false)
    const theme=useContext(ThemeContext)
    const darkMode=theme.state.darkMode;

    const handleSubmit=(e)=>{
        e.preventDefault();
        emailjs.sendForm('service_t5mjd4n', 'template_ixc9m0q', formRef.current, 'user_sY0JYrFdT6fc0NWtdtNKz')
            .then((result) => {
                console.log(result.text);
                setDone(true)
            }, (error) => {
                console.log(error.text);
      });

    }
    
    return (
        <div className="c">
            <div className="c-bg"></div>
            <div className="c-wrapper">
                <div className="c-left">
                    <h1 className="c-title">Let's discuss your project</h1>
                    <div className="c-info">
                        <div className="c-info-item">
                            <img 
                             src={Phone}
                             alt="" 
                             className="c-icon" />
                             +91 9650700000
                        </div>
                        <div className="c-info-item">
                            <img 
                             src={Email}
                             alt="" 
                             className="c-icon" />
                             contact@danish.dev
                        </div>
                        <div className="c-info-item">
                            <img 
                             src={Address}
                             alt="" 
                             className="c-icon" />
                             street no. 30/8 jafrabad delhi 110053
                        </div>
                    </div>
                </div>
                <div className="c-right">
                    <p className="c-desc">
                        <b>What's your story?</b>Get in touch always
                        available for freelancing if the right project 
                        come along me.
                    </p>
                    <form ref={formRef} onSubmit={handleSubmit}>
                        <input style={{background: darkMode && "#333"}}type="text" placeholder="Subject" name="user-subject"/>
                        <input style={{background: darkMode && "#333"}}type="text" placeholder="Name" name="user-name"/>
                        <input style={{background: darkMode && "#333"}}type="text" placeholder="Email" name="user-email"/>
                        <textarea style={{background: darkMode && "#333"} } rows="5" placeholder="Message" name="message"/>
                        <button>Submit</button>
                        {done && " Thank You..."}
                    </form>
                </div>
            </div>
        </div>
    )
}

export default Contact
